import { cn } from "@/modules/lib/utils"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { BoxPlanningHeaderCenterView } from "@modules/boxPlanning/components/boxPlanningHeader/boxPlanningHeaderCenterView"
import { BoxPlanningHeaderLeftView } from "@modules/boxPlanning/components/boxPlanningHeader/boxPlanningHeaderLeftView"
import { BoxPlanningHeaderRightView } from "@modules/boxPlanning/components/boxPlanningHeader/boxPlanningHeaderRightView"
import { Suspense } from "react"

export function BoxPlanningHeader({
  className,
  ...props
}: {
  className?: string
} & React.ComponentProps<"div">) {
  return (
    <div className={cn("flex max-h-52 min-h-52 w-full justify-between gap-1 lg:gap-2 xl:gap-3", className)} {...props}>
      <div className="flex-1/4">
        <BoxPlanningHeaderLeftView />
      </div>
      <div className="flex-2/4">
        <Suspense fallback={<LoadingSpinner />}>
          <BoxPlanningHeaderCenterView />
        </Suspense>
      </div>
      <div className="flex-1/4">
        <BoxPlanningHeaderRightView />
      </div>
    </div>
  )
}
